const useMobile = () => {
  if (/Android|Mobi|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true; // some code..
  }
  return false;
};

export default useMobile;
